module.exports = __webpack_public_path__ + "img/agePirod.a1d926a7.svg";